import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import Diploma from '../Diploma'

export default function LayoutDiploma() {
    return (
        <div>
            <Header />
            <Diploma />
            <Footer />
        </div>
    )
}
